export default function ReviewQueue({
  workers = [],
  onReviewWorker,
}) {
  return (
    <div className="ao-review-queue"
      style={{
        padding: 16,
        borderRadius: 16,
        background: "#ffffff",
        border: "1px solid #e2e8f0",
      }}
    >
      <div style={{ fontSize: 16, fontWeight: 950, marginBottom: 10 }}>
        Review Queue
      </div>

      {workers.length === 0 ? (
        <div style={{ color: "#64748b", fontWeight: 800 }}>
          No workers waiting for document review.
        </div>
      ) : (
        <div style={{ display: "grid", gap: 10 }}>
          {workers.map((u) => (
            <div
              key={u.uid || u.id || u.email}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 14,
                padding: 12,
                background: "#f8fafc",
              }}
            >
<div style={{ fontWeight: 950, color: "#0f172a" }}>
  {u.displayName ||
    u.fullName ||
    [u.firstName, u.lastName].filter(Boolean).join(" ") ||
    u.name ||
    u.email ||
    u.uid ||
    "Worker"}
</div>

<div
  style={{
    marginTop: 3,
    color: "#475569",
    fontSize: 12,
    fontWeight: 800,
  }}
>
  {u.email || u.uid || ""}
</div>

<div
  style={{
    marginTop: 4,
    color: "#64748b",
    fontSize: 12,
    fontWeight: 800,
  }}
>
  {u.facilityId || "No Facility"} •{" "}
  {u.primaryRole ||
    u.position ||
    u.workerType ||
    u.roleType ||
    u.role ||
    u.platformRole ||
    "Worker"}{" "}
  • Review Queue
</div>

              <button
                type="button"
                onClick={() => onReviewWorker?.(u)}
                style={{
                  marginTop: 10,
                  border: "1px solid #2563eb",
                  background: "#2563eb",
                  color: "#fff",
                  borderRadius: 10,
                  padding: "8px 12px",
                  fontWeight: 900,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                Review Docs
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}